<div class="mobile-web-view-timeline">
	<div [ngClass]="{'regular-blue':type === ProgressTimelineType.REGULAR,
	 'percentage-red':type === ProgressTimelineType.PERCENTAGE,
	 'regular-green': type === ProgressTimelineType.REGULAR_GREEN,
	  'timer-progress': type === ProgressTimelineType.TIMER }">
		<nz-progress [nzFormat]="progressText" [nzPercent]="getCurrentStepProgress()" [nzStrokeColor]="strokeColor"
					 [nzStrokeWidth]="strokeWidth" [nzWidth]="size" nzStrokeLinecap="round" nzType="circle">
		</nz-progress>
		<ng-template #progressText>
			<div [ngSwitch]="type">
				<div *ngSwitchCase="ProgressTimelineType.REGULAR">
					<strong><span
						class="current-step {{useLargeFont? LARGE_TITLE_FONT_CLASS : DEFAULT_TITLE_FONT_CLASS}}">{{currentStep}}</span></strong>
					<span
						class="total-step {{useLargeFont? LARGE_DES_FONT_CLASS : DEFAULT_DES_FONT_CLASS}}">/{{totalStep}}</span>
				</div>
				<div *ngSwitchCase="ProgressTimelineType.REGULAR_GREEN">
					<strong><span
						class="current-step  {{useLargeFont? LARGE_TITLE_FONT_CLASS : DEFAULT_TITLE_FONT_CLASS}}">{{currentStep}}</span></strong>
					<span
						class="total-step {{useLargeFont? LARGE_DES_FONT_CLASS : DEFAULT_DES_FONT_CLASS}}">/{{totalStep}}</span>
				</div>
				<div *ngSwitchCase="ProgressTimelineType.PERCENTAGE">
					<div class="percentage">
						<div class="title">
							{{percentage}}%
						</div>
						<div class="label">
							Completed
						</div>
					</div>
				</div>
				<div *ngSwitchCase="ProgressTimelineType.TIMER">
					<div *ngIf="!isTimerHidden" class="font-bold text-center text-black text-4xl md:text-3xl">
						{{formatTime(minute)}}:{{formatTime(second)}}
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</div>
